import InsightsLiteConfig from 'app/config/InsightsLiteConfig';
import { User } from 'types/User';

export function isIncludedInInsightsLiteExperiment({ user }: { user: User }) {
  return InsightsLiteConfig.INCLUDED_ROLES_IN_EXPERIMENT.includes(user.role);
}
